module.exports = __webpack_public_path__ + "img/info-transport.9961d316.svg";